const enum Api {
  STORAGE = "STORAGE",
  ISAAC = "ISAAC",
  ICC = "ICC",
}

export default Api;
